

<ng-container *ngIf="can(Action.View, Subject.Chat); else noAccess">
  <div class="messaging-container">
    <!-- Left Sidebar - Conversations -->
    <div class="conversations-sidebar"  *ngIf="!isMobile || currentView === 'conversations'">
      <div class="sidebar-header">
        <h2 class="sidebar-title">Messages</h2>
      </div>

      <!-- Search -->
      <div class="search-container">
        <div class="search-input-wrapper">
          <i class="bi bi-search search-icon"></i>
          <input
            type="text"
            class="search-input"
            placeholder="Search"
            [(ngModel)]="searchQuery">
        </div>
      </div>

      <!-- Filter Tabs -->
      <div class="filter-tabs mb-4">
        <button
          class="filter-tab"
          [class.active]="activeTab === 'all'"
          (click)="setActiveTab('all')">
          All
        </button>
        <button
          class="filter-tab"
          [class.active]="activeTab === '1-on-1'"
          (click)="setActiveTab('1-on-1')">
          DMs
        </button>
        <button
          class="filter-tab"
          [class.active]="activeTab === 'groups'"
          (click)="setActiveTab('groups')">
          Groups
        </button>
        <!-- <button
          class="filter-tab queries-tab"
          [class.active]="activeTab === 'queries'"
          (click)="setActiveTab('queries')">
          Queries
        </button> -->
      </div>

      <!-- All / Unread Tabs -->
      <div class="unread-tabs" *ngIf="false">
        <button
          class="unread-tab"
          [class.active]="activeUnreadTab === 'all'"
          (click)="setActiveUnreadTab('all')">
          All
        </button>
        <button
          class="unread-tab"
          [class.active]="activeUnreadTab === 'unread'"
          (click)="setActiveUnreadTab('unread')">
          Unread
          <span class="unread-count">{{ getUnreadTotal() }}</span>
        </button>
      </div>


      <!-- Conversations List -->
      <div class="conversations-list" >
        <div class="conversation-item"
          *ngFor="let conversation of getFilteredConversations()"
          [class.active]="activeConversation?.id === conversation.id"
          (click)="selectConversation(conversation)">

          <div class="conversation-avatar">
            <img [src]="conversation.avatar"  [alt]="conversation.name" (error)="onImgError($event)">
            <div class="status-indicator" *ngIf="conversation.type === 'parent-query'"></div>
          </div>

          <div class="conversation-content">
            <div class="conversation-header">
              <span class="conversation-name" [ngClass]="{ 'text-gray': conversation.status === 'new' }">
                {{ conversation.name | string : 'title' }}
                <i class="bi bi-patch-check-fill" *ngIf="conversation.group_id !== '000000000000000000000000' || conversation.default_type != ''"></i>
              </span>
              <span class="conversation-time">{{ conversation.last_message?.edited_at| dateTime:'hh:mm a' }}</span>
            </div>
            <div class="conversation-preview" >
              <span class="last-message">{{ conversation.last_message?.content| string:'sentence' }}</span>
              <div class="conversation-badges">
                <!-- {{conversation.status}} -->
                <span
                  class="status-badge mb-1"
                    [ngClass]="getStatusBadgeClass(conversation.status)"
                    *ngIf="conversation.status !== 'resolved' && !conversation.last_message?.seen && conversation.last_message?.content == 'Create chat'">
                  <!-- {{ conversation.status === 'new' ? '' : '' }} -->
                  <ng-container *ngIf="conversation.status === 'new'">
                    <i class="bi bi-envelope-arrow-down"></i>
                  </ng-container>
                </span>
                <span
                  class="unread-badge"
                  *ngIf="conversation.unreadCount > 0">
                  {{ conversation.unreadCount }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="empty-state" *ngIf="!is_loading_conversations && (!getFilteredConversations() || getFilteredConversations().length === 0)">
          <div class="empty-icon">
            <i class="bi bi-people"></i>
          </div>
          <h3 class="empty-title">
            <span *ngIf="!search_empty">No chat created yet</span>
            <span *ngIf="search_empty">No conversations found.</span>
          </h3>
          <p class="empty-subtitle" *ngIf="!search_empty">
            Create a chat using the <strong>'New chat'</strong> button
          </p>
        </div>
        <div *ngIf="is_loading_conversations" class="d-flex flex-column" style="gap: .325rem;">
            <app-skeleton-loader [type]="'square'" class="mb-2" [width]="320" [height]="68" *ngFor="let elm of [1,2,3,4,5]"></app-skeleton-loader>
          <!-- </div> -->
        </div>
      </div>

      <!-- New Chat Button -->
      <button matRipple class="new-chat-btn new-chat-btn btn btn-primary main-height" (click)="openNewChatModal()" *ngIf="can(Action.Create, Subject.Chat)">
        New chat
        <!-- openMediumModal(chatModal) -->
      </button>
    </div>

    <!-- Main Chat Area -->
    <div class="chat-main"  *ngIf="!isMobile || currentView === 'chat'" >
      <div class="chat-header" *ngIf="activeConversation">

        <div class="chat-header-left">
          <button class="back-btn" (click)="goBack()">
            <i class="bi bi-arrow-left"></i>
          </button>
          <div class="d-flex align-items-center" (click)="toggleMoreInfo();">
            <div class="participant-avatar">
              <img [src]="activeConversation.avatar" alt="-" (error)="onImgError($event)">
            </div>
            <div class="participant-info">
              <h3 class="participant-name over-flow-word">{{ activeConversation.name }}</h3>
              <span class="participant-count" *ngIf="activeConversation?.type!=='direct'">{{participants.length||"-"}} Members</span>
              <!-- <span class="participant-count" *ngIf="activeConversation?.type ==='direct' && !ws.onlineUsers.has(participant)"></span> -->
              <span class="participant-online" *ngIf="activeConversation?.type ==='direct' && ws.onlineUsers.has(participant)">Online</span>
            </div>
          </div>
        </div>
        <div class="chat-header-right">
          <!-- <button class="more-info-btn" (click)="toggleMoreInfo()">
            More info
          </button> -->
          <div class="dropdown">
            <button class="btn btn-link p-0 text-dark" type="button"
                    id="dropdownMenuButton" data-bs-toggle="dropdown"
                    aria-expanded="false">
              <i class="bi bi-three-dots-vertical fs-5"></i>
            </button>
            <div class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
              <button class="dropdown-item d-flex align-items-center" style="font-size: 14px;" (click)="toggleMoreInfo(); openInfo()">
                <i class="bi bi-info-circle me-2"></i> Info
              </button>
              <button class="dropdown-item d-flex align-items-center text-danger" style="font-size: 14px;"
                [swal]="warningWithDeleteChat" *ngIf="activeConversation?.group_id === '000000000000000000000000' && can(Action.Delete, Subject.Chat)">
                <i class="bi bi-trash3 me-2" ></i> Delete chat
              </button>
            </div>
          </div>
          <swal #warningWithDeleteChat type="warning"
              title="Are you sure?" confirmButtonText="Delete"
              text="Do you want to delete this chat named '{{ activeConversation.name }}'?"
              [showCancelButton]="true"
              (confirm)="deleteChat()"
              cancelButtonClass="btn btn-danger"></swal>
        </div>
      </div>
      <div class="welcome-empty" *ngIf="!activeConversation">
        <div class="welcome-icon">
          <i class="bi bi-chat-square-text"></i>
        </div>
        <h2 class="welcome-title">Welcome to Dartle chat</h2>
          <p class="welcome-subtitle">
            <span *ngIf="!is_loading_conversations">Select a conversation from the left to start chatting with your coaches,groups.</span>
            <span *ngIf="is_loading_conversations">Loading chats</span>
            <!-- , or get help from the AI Assistant. -->
          </p>
        <div class="welcome-features">
          <!-- <div class="feature">
            <i class="bi bi-robot"></i>
            <span>AI Assistant for instant help</span>
          </div> -->
          <div class="feature">
            <i class="bi bi-people"></i>
            <span>Team and group conversations</span>
          </div>
          <div class="feature">
            <i class="bi bi-person"></i>
            <span>Direct coach messaging</span>
          </div>
        </div>
      </div>


      <!-- Query Status -->
      <div class="query-status" *ngIf="activeConversation?.type === 'parent-query'">
        <div class="query-content">
          <div class="chat-badges">
            <span class="badge badge-query" *ngIf="activeConversation?.type === 'parent-query'">Parent query</span>
            <span class="badge badge-urgent">Urgent</span>
          </div>
          <p class="query-text">Hi Coach, Emma has been feeling unwell. Can she sit out of practice today?</p>
          <div class="query-meta">
            <span class="query-status-label">{{ activeConversation?.status === 'resolved' ? 'Resolved' : 'In progress' }}</span>
            <button class="resolve-btn" *ngIf="activeConversation?.status !== 'resolved'" (click)="markAsResolved()">
              Mark as resolved
            </button>
          </div>
        </div>

      </div>

      <!-- Messages Area -->
      <div class="messages-area" *ngIf="activeConversation" #chatContainer (scroll)="onScrollMessage()">
        <!-- Top loader sentinel shown when loading older pages and we already have messages -->
        <div class="top-loader" *ngIf="loadingOlder && state.messagesForActive()?.length">
          <app-skeleton-loader [type]="'square'" class="message mb-2" [width]="420" [height]="36"></app-skeleton-loader>
        </div>
        <div *ngIf="noMoreMessages" class="no-more-msg">
          No more messages
        </div>


        <div *ngFor="let day of groupedMessages">
          <!-- Date Separator -->
          <div class="date-separator text-center my-2">
            <span class="badge bg-light text-dark px-3 py-1 rounded-pill shadow-sm">
              {{ formatDateSeparator(day.date) }}
                <!-- {{day.date| dateTime}} -->
            </span>
          </div>
          <!-- Sender Groups inside the Date -->
          <div *ngFor="let group of day.groups" class="message-group mb-3"
              [ngClass]="group.senderId === delegate ? 'own-group' : 'other-group'">
              <div class="d-flex">
                <div class="message-avatar" [ngClass]="group.sender_id === delegate?'own-message chatbot-message':''" *ngIf="group.sender_id !== delegate">
                  <img [src]="participantsMap.get(group.sender_id)?.avatar" *ngIf="participantsMap.get(group.sender_id)?.avatar"  (error)="onImgError($event)"[alt]="participantsMap.get(group.sender_id)?.name?.charAt(0)">
                  <img [src]="deletedUserMap.get(group.sender_id)?.avatar" *ngIf="!participantsMap.get(group.sender_id)?.avatar"  (error)="onImgError($event)"[alt]="participantsMap.get(group.sender_id)?.name?.charAt(0)">
                </div>
                <!-- Header -->
                <div class="message-header">
                  <span class="sender-name" *ngIf="participantsMap.get(group.sender_id)?.name && group.sender_id !== delegate">{{participantsMap.get(group.sender_id)?.name}}</span>
                  <span class="sender-name" *ngIf="!participantsMap.get(group.sender_id)?.name && group.sender_id !== delegate && isParticipantsLoaded">{{deletedUserMap.get(group.sender_id)?.name ||"Member"}}</span>
                  <!-- - (deleted) -->
                </div>
              </div>

              <div class="message" *ngFor="let message of group.messages; trackBy: trackByMessageId" [ngClass]="message.sender_id === delegate?'own-message chatbot-message':''" >

                <!-- <div class="message-content position-relative" *ngIf="!message.deleted">

                  <div *ngIf="!message.is_editing; else editTemplate"
                      class="message-text d-flex flex-column"
                      [ngClass]="message.sender_id === delegate ? 'chatbot-text sender-message' : 'reciever-message'">
                    <span class="paragraph-line">{{ message.content }}</span>

                    <span class="d-flex justify-content-end">
                      <span class="message-time me-2" [ngClass]="{ 'delegate-time': message.sender_id === delegate }">{{ message.created_at | dateTime:'hh:mm a' }}</span>
                      <span class="message-edited" *ngIf="message.edited" [ngClass]="{ 'delegate-time': message.sender_id === delegate }">Edited</span>
                    </span>
                  </div>


                  <div class="message-actions dropdown mt-4" *ngIf="delegate === message.sender_id">
                    <button class="btn btn-link p-0 text-muted"
                            data-bs-toggle="dropdown"
                            aria-expanded="false">
                      <i class="bi bi-three-dots-vertical"></i>
                    </button>
                    <div class="dropdown-menu">
                      <button class="dropdown-item" style="font-size: 12px;" (click)="onEditMessage(message)">
                        <i class="bi bi-pencil-square me-2"></i>Edit
                      </button>
                      <button [swal]="warningWithDeleteMessage" class="dropdown-item text-danger" style="font-size: 12px;">
                        <i class="bi bi-trash3 me-2"></i>Delete
                      </button>
                      <swal #warningWithDeleteMessage type="warning" style="display: none;"
                        title="Are you sure?" confirmButtonText="Delete"
                        text="Do you want to delete this message?"
                        [showCancelButton]="true"
                        (confirm)="onDeleteMessage(message)"
                        cancelButtonClass="btn btn-danger"></swal>
                    </div>
                  </div>


                  <div class="d-flex justify-content-end" *ngIf="false">
                    <span *ngIf="message.delivered && !message.deleted"  matTooltip="Seen">
                      <i class="bi bi-check2"></i>
                      <i class="bi bi-check2"></i>
                    </span>
                    <span *ngIf="!message.delivered && !message.deleted"  matTooltip="Sent">
                      <i class="bi bi-check2"></i>
                    </span>
                  </div>

                  <ng-template #editTemplate>
                    <div class="edit-container">
                      <textarea
                        matInput
                        cdkTextareaAutosize
                        cdkAutosizeMinRows="1"
                        cdkAutosizeMaxRows="5"
                        #autosize="cdkTextareaAutosize"
                        class="form-control mb-2 message-input main-text-edit"
                        placeholder="Enter here.."
                        [(ngModel)]="message.content"
                        (input)="autosize.resizeToFitContent(true)">
                      </textarea>
                      <div class="d-flex gap-2 justify-content-end">
                        <i class="bi bi-check2 text-lg1 pointer edit-icons" matTooltip="Done" (click)="saveEdit(message)"></i>
                        <i class="bi bi-x text-lg1 pointer edit-icons" matTooltip="Cancel" (click)="cancelMessageEdit(message)"></i>
                      </div>
                    </div>
                  </ng-template>
                </div> -->





                <!-- including media  -->

                <div class="message-content position-relative" *ngIf="!message.deleted" [appInViewport]="message.id" (seen)="onSeen(message.id, message)">

                  <div *ngIf="!message.is_editing; else editTemplate">
                    <div *ngIf="message.type === 'text'"
                        class="message-text d-flex flex-column"
                        [ngClass]="message.sender_id === delegate ? 'chatbot-text sender-message' : 'reciever-message'">
                        <span class="paragraph-line">
                          <ng-container *ngIf="isUrl(message.content); else normalText">
                              <a [href]="message.content"
                                target="_blank"
                                rel="noopener noreferrer"
                                class="message-link">
                                {{ message.content }}
                                <i class="bi bi-box-arrow-up-right ms-1"></i>
                              </a>
                          </ng-container>
                          <ng-template #normalText>
                            {{ message.content }}
                          </ng-template>
                        </span>

                      <span class="d-flex justify-content-end">
                        <span class="message-time me-2"
                              [ngClass]="{ 'delegate-time': message.sender_id === delegate }">
                          {{ message.created_at | dateTime:'hh:mm a' }}
                        </span>
                        <span class="message-edited"
                              *ngIf="message.edited"
                              [ngClass]="{ 'delegate-time': message.sender_id === delegate }">
                          Edited
                        </span>
                      </span>
                    </div>

                    <div class="message-text" *ngIf="message.type === 'image'"
                      [ngClass]="message.sender_id === delegate ? 'chatbot-text sender-message' : 'reciever-message'">
                      <div class="image-message">
                        <ng-container *ngFor="let file of message.media; let i = index">
                          <app-file-preview
                            [file]="{ path: file.url, type: file.mime_type, name: file.name }"
                            [index]="i">
                          </app-file-preview>
                        </ng-container>
                      </div>
                      <span class="paragraph-line">
                        <ng-container *ngIf="isUrl(message.content); else normalText">
                          <a [href]="message.content"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="message-link">
                            {{ message.content }}
                            <i class="bi bi-box-arrow-up-right ms-1"></i>
                          </a>
                        </ng-container>
                        <ng-template #normalText>
                          {{ message.content }}
                        </ng-template>
                      </span>
                      <span class="d-flex justify-content-end">
                        <span class="message-time me-2"
                              [ngClass]="{ 'delegate-time': message.sender_id === delegate }">
                          {{ message?.created_at | dateTime:'hh:mm a' }}
                        </span>
                        <span class="message-edited"
                              *ngIf="message.edited"
                              [ngClass]="{ 'delegate-time': message.sender_id === delegate }">
                          Edited
                        </span>
                      </span>
                    </div>

                    <div class="message-text" *ngIf="message.type === 'video'"
                        [ngClass]="message.sender_id === delegate ? 'chatbot-text sender-message' : 'reciever-message'">
                      <div class="video-message">
                        <ng-container *ngFor="let file of message.media; let i = index">
                          <app-file-preview
                            [file]="{ path: file.url, type: file.mime_type, name: file.name }"
                            [index]="i">
                          </app-file-preview>
                        </ng-container>
                      </div>
                      <span class="paragraph-line">
                        <ng-container *ngIf="isUrl(message.content); else normalText">
                          <a [href]="message.content"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="message-link">
                            {{ message.content }}
                            <i class="bi bi-box-arrow-up-right ms-1"></i>
                          </a>
                        </ng-container>
                        <ng-template #normalText>
                          {{ message.content }}
                        </ng-template>
                      </span>
                      <span class="d-flex justify-content-end">
                        <span class="message-time me-2"
                              [ngClass]="{ 'delegate-time': message.sender_id === delegate }">
                          {{ message?.created_at | dateTime:'hh:mm a' }}
                        </span>
                        <span class="message-edited"
                              *ngIf="message.edited"
                              [ngClass]="{ 'delegate-time': message.sender_id === delegate }">
                          Edited
                        </span>
                      </span>
                    </div>

                    <div class="message-text" *ngIf="message.type === 'document'"
                        [ngClass]="message.sender_id === delegate ? 'chatbot-text sender-message' : 'reciever-message'">
                      <div class="document-message align-items-center p-2"
                      [ngClass]="{ 'document-message': message.sender_id === delegate, 'document-message1': message.sender_id !== delegate }">
                        <div class="doc-header">
                          <i class="bi bi-file-earmark-text me-2 doc-icon"></i>
                          <div class="doc-details flex-grow-1">
                            <a [href]="message.media[0].url" target="_blank" class="doc-name over-flow-word">
                              {{ message.media[0].name || 'Document' }}
                            </a>
                            <div class="doc-meta text-muted">
                              {{ message.media[0].mime_type || 'File' }}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div style="padding: 0px 10px !important;">
                        <span class="paragraph-line">
                          <ng-container *ngIf="isUrl(message.content); else normalText">
                              <a [href]="message.content"
                                target="_blank"
                                rel="noopener noreferrer"
                                class="message-link">
                                {{ message.content }}
                                <i class="bi bi-box-arrow-up-right ms-1"></i>
                              </a>
                          </ng-container>
                          <ng-template #normalText>
                            {{ message.content }}
                          </ng-template>
                        </span>
                      </div>

                      <span class="message-time ms-2 small text-muted d-flex justify-content-end">
                        <span class="message-time me-2"
                              [ngClass]="{ 'delegate-time': message.sender_id === delegate }">
                          {{ message?.created_at | dateTime:'hh:mm a' }}
                        </span>
                        <span class="message-edited"
                              *ngIf="message.edited"
                              [ngClass]="{ 'delegate-time': message.sender_id === delegate }">
                          Edited
                        </span>
                      </span>
                    </div>
                  </div>


                  <div class="message-actions dropdown mt-4" *ngIf="delegate === message.sender_id && message.status !== 'sending' && message.status !== 'failed'">
                    <button class="btn btn-link p-0 text-muted"
                            data-bs-toggle="dropdown"
                            aria-expanded="false">
                      <i class="bi bi-three-dots-vertical"></i>
                    </button>
                    <div class="dropdown-menu">
                      <button class="dropdown-item" style="font-size: 12px;" (click)="onEditMessage(message)">
                        <i class="bi bi-pencil-square me-2"></i>Edit
                      </button>
                      <button [swal]="warningWithDeleteMessage" class="dropdown-item text-danger" style="font-size: 12px;">
                        <i class="bi bi-trash3 me-2"></i>Delete
                      </button>
                      <swal #warningWithDeleteMessage type="warning" style="display: none;"
                        title="Are you sure?" confirmButtonText="Delete"
                        text="Do you want to delete this message?"
                        [showCancelButton]="true"
                        (confirm)="onDeleteMessage(message)"
                        cancelButtonClass="btn btn-danger"></swal>
                    </div>
                  </div>

                  <!-- Optimistic-UI delivery status (own messages) -->
                  <div class="d-flex justify-content-end align-items-center gap-2" *ngIf="delegate === message.sender_id">
                    <!-- Sending: waiting for the server ack -->
                    <span *ngIf="message.status === 'sending'" class="text-muted" matTooltip="Sending">
                      <i class="bi bi-clock"></i>
                    </span>

                    <!-- Failed: never removed silently; offer retry / delete -->
                    <ng-container *ngIf="message.status === 'failed'">
                      <span class="text-danger small">Failed</span>
                      <i class="bi bi-arrow-clockwise text-danger pointer" matTooltip="Retry" (click)="retryMessage(message)"></i>
                      <i class="bi bi-trash3 text-danger pointer" matTooltip="Delete" (click)="deleteFailedMessage(message)"></i>
                    </ng-container>

                    <!-- Sent / confirmed (also covers historical messages with no status) -->
                    <span *ngIf="message.status !== 'sending' && message.status !== 'failed' && activeConversation?.type === 'direct'" matTooltip="Sent">
                      <i class="bi bi-check2"></i>
                    </span>
                  </div>

                  <ng-template #editTemplate>
                    <div class="edit-container">
                      <textarea
                        matInput
                        cdkTextareaAutosize
                        cdkAutosizeMinRows="1"
                        cdkAutosizeMaxRows="5"
                        #autosize="cdkTextareaAutosize"
                        class="form-control mb-2 message-input main-text-edit"
                        placeholder="Enter here.."
                        [(ngModel)]="message.content"
                        (input)="autosize.resizeToFitContent(true)">
                      </textarea>
                      <div class="d-flex gap-2 justify-content-end">
                        <i class="bi bi-check2 text-lg1 pointer edit-icons" matTooltip="Done" (click)="saveEdit(message)"></i>
                        <i class="bi bi-x text-lg1 pointer edit-icons" matTooltip="Cancel" (click)="cancelMessageEdit(message)"></i>
                      </div>
                    </div>
                  </ng-template>
                </div>



                <div class="message-content" *ngIf="message.deleted">

                  <div class="message-text" [ngClass]="message.sender_id === delegate?'chatbot-text':''">
                    <i>This message has been deleted.</i>
                  </div>
                  <div class="message-header d-flex justify-content-end">
                    <!-- <span class="sender-name" *ngIf="message.sender_id !== delegate">{{participantsMap?.get(message.sender_id)?.name}}</span> -->
                    <span class="message-time">{{ message.created_at | dateTime:'hh:mm a' }}</span>
                    <!-- {{ message.created_at | dateTime }}  -->
                  </div>
                </div>
              </div>
          </div>
        </div>



        <div *ngIf="is_loading_messages" >
          <app-skeleton-loader [type]="'square'" class="message mb-2" [width]="420" [height]="48" *ngFor="let elm of [1]"></app-skeleton-loader>
          <app-skeleton-loader [type]="'square'" class="message chatbot-message mb-2" [width]="420" [height]="48" *ngFor="let elm of [1]"></app-skeleton-loader>
          <app-skeleton-loader [type]="'square'" class="message mb-2" [width]="420" [height]="48" *ngFor="let elm of [1,2,3]"></app-skeleton-loader>
          <app-skeleton-loader [type]="'square'" class="message chatbot-message mb-2" [width]="420" [height]="48" *ngFor="let elm of [1,2]"></app-skeleton-loader>
        </div>
        <div class="chatbot-message" *ngIf="false">
          <div class="chatbot-avatar">
            <img src="images/icons/dartle chatbot profile picture.png" alt="" style="height: 45px;">
            <!-- style="width: 2rem; margin-left: 10px; height: 2rem; border-radius: 5px;" -->
            <!-- <i class="bi bi-robot"></i> -->
          </div>
          <div class="chatbot-content">
            <div class="chatbot-text">Do you want me to escalate the query to a coach?</div>
            <button class="escalate-btn" (click)="escalateQuery()">
              Forwarding Query to a coach for further assistance
            </button>
          </div>
        </div>
        <div class="system-message" *ngIf="false">
          <span class="system-text">Parent query escalated from chatbot assistance</span>
        </div>

        <div class="system-message" *ngIf="false">
          <span class="system-text">Marked as Resolved</span>
          <span class="system-time">10:45 AM</span>
        </div>

        <!-- Jump-to-latest FAB: appears when scrolled up; badge counts new messages -->
        <div class="scroll-to-bottom-wrap" *ngIf="showScrollToBottom">
          <button class="scroll-to-bottom-fab" (click)="jumpToLatest()" matTooltip="Jump to latest" [matTooltipPosition]="'above'">
            <i class="bi bi-chevron-down"></i>
            <span class="fab-badge" *ngIf="newMessageCount > 0">{{ newMessageCount > 99 ? '99+' : newMessageCount }}</span>
          </button>
        </div>
      </div>

      <!-- Message Input -->
      <!-- <div class="message-input-container">
        <button class="attachment-btn" *ngIf="false">
          <i class="bi bi-paperclip"></i>
        </button>
        <textarea
          type="text"
          matInput
          cdkTextareaAutosize
          cdkAutosizeMinRows="1"
          cdkAutosizeMaxRows="5"
          #autosize="cdkTextareaAutosize"
          class="message-input"
          style="min-height: 40px;"
          placeholder="Type a message"
          [(ngModel)]="newMessage"
          (input)="autosize.resizeToFitContent(true)"
          (keydown.enter)="onEnterPress($event)">
        </textarea>
        <button class="send-btn" (click)="sendMessage()" matTooltip="Send" [matTooltipPosition]="'above'">
          <i class="bi bi-send-fill"></i>
        </button>
      </div> -->


  <!--   -->
      <div class="typing-indicator" *ngIf="typingLabel">
        <span class="typing-dots"><span></span><span></span><span></span></span>
        <span class="typing-text">{{ typingLabel }}</span>
      </div>
      <div class="message-input-container flex-column"
        (drop)="onFileDrop($event)"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        [class.drag-over]="isDragOver">

        <!-- Show selected file preview -->
        <div *ngIf="attachedFile" class="file-preview">
          <ng-container [ngSwitch]="fileType">
            <!-- Image -->
            <div *ngSwitchCase="'image'" class="preview-box">
              <img [src]="filePreview" alt="Preview" class="preview-thumb">
              <div class="file-info">
                <span class="file-name" [title]="attachedFile.name">{{ attachedFile.name }}</span>
                <!-- <span class="file-size">{{ attachedFile.size | number }} KB</span> -->
              </div>
              <button (click)="removeFile()" class="remove-btn">
                <i class="bi bi-trash"></i>
              </button>
              <div class="upload-overlay" *ngIf="uploadProgress !== 100">
                <div class="spinner-border text-primary" role="status"></div>
              </div>
            </div>

            <!-- Video -->
            <div *ngSwitchCase="'video'" class="preview-box">
              <video [src]="filePreview" class="preview-thumb" muted></video>
              <div class="file-info">
                <span class="file-name" [title]="attachedFile.name">{{ attachedFile.name }}</span>
                <!-- <span class="file-size">{{ attachedFile.size | number }} KB</span> -->
              </div>
              <button (click)="removeFile()" class="remove-btn">
                <i class="bi bi-trash"></i>
              </button>
              <div class="upload-overlay" *ngIf="uploadProgress !== 100">
                <div class="spinner-border text-primary" role="status"></div>
              </div>
            </div>

            <!-- Document / Default -->
            <div *ngSwitchDefault class="preview-box">
              <i class="bi bi-file-earmark-text doc-icon"></i>
              <div class="file-info">
                <span class="file-name" [title]="attachedFile.name">{{ attachedFile.name }}</span>
                <!-- <span class="file-size">{{ attachedFile.size | number }} KB</span> -->
              </div>
              <button (click)="removeFile()" class="remove-btn">
                <i class="bi bi-trash"></i>
              </button>
              <div class="upload-overlay" *ngIf="uploadProgress !== 100">
                <div class="spinner-border text-primary" role="status"></div>
              </div>
            </div>
          </ng-container>
        </div>

        <div class="d-flex w-100">
          <!-- Attachment Button -->
          <button class="attachment-btn" (click)="openAttachmentMenu()"
              matTooltip="Attach file"
              [matTooltipPosition]="'above'">
            <i class="bi bi-paperclip"></i>
          </button>
          <input type="file" #fileInput hidden (change)="onFileSelect($event)">

            <!-- Popup menu -->
          <div class="attachment-menu" *ngIf="isAttachmentMenuOpen">
            <div class="menu-item" (click)="triggerFileInput('image')">
              <i class="bi bi-image"></i> Image
            </div>
            <div class="menu-item" (click)="triggerFileInput('video')">
              <i class="bi bi-camera-video"></i> Video
            </div>
            <!-- <div class="menu-item" (click)="triggerFileInput('audio')">
              <i class="bi bi-mic"></i> Audio
            </div> -->
            <div class="menu-item" (click)="triggerFileInput('document')">
              <i class="bi bi-file-earmark"></i> Document
            </div>
          </div>
          <!-- Text Area -->
          <textarea
            type="text"
            matInput
            cdkTextareaAutosize
            cdkAutosizeMinRows="1"
            cdkAutosizeMaxRows="5"
            #autosize="cdkTextareaAutosize"
            class="message-input"
            style="min-height: 40px;"
            placeholder="Type a message"
            [(ngModel)]="newMessage"
            (input)="autosize.resizeToFitContent(true);onTyping()"
            (blur)="onTypingStop()"
            [disabled]="!!attachedFile && uploadProgress !== 100 || is_loading_messages"
            (keydown.enter)="onEnterPress($event)">
          </textarea>
          <!-- <span>{{uploadProgress}}%</span> -->
          <!-- Send Button -->
          <button class="send-btn" [disabled]="!!attachedFile && uploadProgress !== 100 || is_loading_messages" (click)="sendMessage()" matTooltip="Send" [matTooltipPosition]="'above'">
            <i class="bi bi-send-fill"></i>
          </button>
        </div>

      </div>
    </div>

    <!-- Right Sidebar - More Info -->
    <div class="info-sidebar"  *ngIf="(!isMobile && showMoreInfo) || (isMobile && currentView === 'info')">
      <div class="info-header pt-0">
        <!-- <h3 class="info-title">{{ activeConversation?.type === '1-on-1' ? 'Parent info' : 'More info' }}</h3> -->
        <div class="d-flex flex-column" *ngIf="activeConversation?.type === 'group'">
          <h3 class="info-title mb-1" style="height: 30px;">Group info</h3>
          <!-- <div class="d-flex" style="align-items: baseline;">
            <div class="participant-avatar me-2">
              <img [src]="activeConversation?.avatar" [alt]="activeConversation?.name" style="height: 30px; width: 30px; border-radius: 50%;">
            </div>
            <div class="participant-info">
              <h3 class="participant-name" style="font-weight: 400;">{{ activeConversation?.name }}</h3>
            </div>
            <i class="bi bi-pencil-square edit-icon ms-2"></i>
          </div> -->
          <div class="d-flex align-items-baseline">
            <!-- Avatar with overlay -->
            <div class="participant-avatar-info me-2 position-relative" style="height: 30px; width: 30px;">
              <img [src]="activeConversation?.avatar"
                  [alt]="activeConversation?.name"
                  (error)="onImgError($event)"
                  style="height: 35px; width: 35px; border-radius: 50%; object-fit: cover;">

              <!-- Overlay for edit -->
              <div class="avatar-overlay-info mt-2" *ngIf="isEditing" (click)="fileInput.click()">
                <i class="bi bi-camera-fill text-white"></i>
                <input type="file" accept="image/*" #fileInput hidden (change)="onImagePicked($event)">
              </div>
            </div>

            <!-- Name (editable / non-editable) -->
            <div class="participant-info ms-2">
              <h3 class="participant-name over-flow-word" [title]="activeConversation?.name" *ngIf="!isEditing" style="height: 30px; font-weight: 400; max-width: 12rem;">
                {{ (activeConversation?.name || '') | string:'sentence' }}
              </h3>
              <div class="d-flex flex-column">
                <input *ngIf="isEditing"
                    [(ngModel)]="editedName"
                    type="text"
                    class="form-control form-control-sm mt-2"
                    style="max-width: 200px; display: inline-block; height: 2rem;">
                <small style="font-size: 12px;" class="text-danger" *ngIf="editedName.trim().length === 0 && isEditing">Group name cannot be empty.</small>
              </div>

            </div>

            <!-- Action buttons -->
            <div class="ms-2 mt-2">
              <!-- Edit Icon -->
              <i class="bi bi-pencil-square edit-icon"
                *ngIf="!isEditing && activeConversation?.group_id === '000000000000000000000000' && can(Action.Update, Subject.Chat)"
                matTooltip="Edit"
                style="cursor: pointer;"
                (click)="enableEdit()"></i>

              <!-- Confirm / Cancel Icons -->
              <ng-container *ngIf="isEditing">
                <i class="bi bi-check2 text-success me-2"
                matTooltip="Save"
                  style="cursor: pointer; font-size: 1.2rem;"
                  (click)="confirmEdit()"></i>
                <i class="bi bi-x text-danger"
                matTooltip="Cancel"
                  style="cursor: pointer; font-size: 1.2rem;"
                  (click)="cancelEdit()"></i>
              </ng-container>
            </div>
          </div>

        </div>


        <button class="close-info-btn" *ngIf="!isEditing" (click)="toggleMoreInfo(); openChat()" matTooltip="Close">
          <i class="bi bi-x"></i>
        </button>
      </div>

      <!-- Participant Info -->
      <div class="participant-section">
        <!-- <div class="section-header">
          <img src="images/icons/ri_parent-fill.png" alt="" style="height: 15px;">
          <span>Parent</span>
        </div>
        <div class="participant-card">
          <img src="/images/samples/my_jump_lab.png" alt="Parent" class="participant-avatar-small">
          <div class="participant-details">
            <span class="participant-name-small">Basil Joseph</span>
            <span class="participant-role">Parent</span>
          </div>
        </div> -->
        <button matRipple class="new-chat-btn new-chat-btn btn btn-primary main-height w-100 mt-3 mb-4"
          style="height: 2rem; border-radius: 10px !important;" *ngIf="activeConversation?.group_id === '000000000000000000000000' && activeConversation?.type !=='direct' && can(Action.Update, Subject.Chat)" (click)="openMediumModal(newChatPopup)">
        <i class="bi bi-plus"></i> Add member
        </button>
        <div class="section-header">
          <img src="images/icons/codicon_jersey.png" alt="" style="height: 15px;">
          <span>Members({{participants.length}})</span>
        </div>
          <div class="participant-card d-flex justify-content-between" *ngFor="let part of participants">
            <div class="d-flex">
              <div style="position: relative;">
                <img [src]="part.avatar" (error)="onImgError($event)" alt="{{part.name.charAt(0).toUpperCase()}}" class="participant-avatar-small me-2">
                <div class="status-indicator" [ngClass]="part.is_online ? 'online' : 'offline'"></div>
              </div>
              <div class="participant-details" matTooltip="{{part.name | string:'title'}}">
                <span class="participant-name-small over-flow-word" >
                  {{part.name | string:'title'}}
                </span>
                <span class="participant-role">{{part.profile_type[0]}}</span>
              </div>
            </div>
            <button class="close-member-btn" [swal]="warningWithDeleteMember" matTooltip="Remove member"  *ngIf="activeConversation?.group_id === '000000000000000000000000' && activeConversation?.type !=='direct' && can(Action.Update, Subject.Chat)" >
              <i class="bi bi-x"></i>
            </button>
            <swal #warningWithDeleteMember type="warning" style="display: none;"
                title="Are you sure?" confirmButtonText="Delete"
                text="Do you want to delete this member named '{{ part.name | string:'title' }}'?"
                [showCancelButton]="true"
                (confirm)="removeParticipantFromConversation(part)"
                cancelButtonClass="btn btn-danger"></swal>
          </div>

        <div class="participant-card" *ngIf="is_loading_participant">
          <div class="d-flex">
            <app-skeleton-loader [type]="'circle'" [height]="40" [width]="40"></app-skeleton-loader>
            <app-skeleton-loader [type]="'square'" [height]="25" [width]="100"></app-skeleton-loader>
          </div>
        </div>
      </div>

      <!-- Info Tabs -->
      <div class="info-tabs">
        <button
          class="info-tab"
          [class.active]="activeInfoTab === 'media'"
          (click)="setActiveInfoTab('media')">
          Media
          <span class="tab-count">{{allMessages.length}}</span>
        </button>
        <!-- <button
          class="info-tab"
          [class.active]="activeInfoTab === 'links'"
          (click)="setActiveInfoTab('links')">
          Links
          <span class="tab-count">4</span>
        </button>
        <button
          class="info-tab"
          [class.active]="activeInfoTab === 'queries'"
          (click)="setActiveInfoTab('queries')">
          Queries
          <span class="tab-count">8</span>
        </button> -->
      </div>

      <!-- Tab Content -->
      <div class="tab-content">
        <!-- Media Tab -->
        <div class="media-list" *ngIf="activeInfoTab === 'media'">
          <div class="media-item" *ngFor="let message of allMessages">
            <ng-container *ngFor="let media of message.media; let i = index">

              <div class="media-icon">
                <!-- Images & Videos -->
                <ng-container *ngIf="media.type === 'image' || media.type === 'video'; else documentBlock">
                  <div class="media-preview-small">
                    <app-file-preview
                      [file]="{ path: media.url, type: media.mime_type, name: media.name }"
                      [index]="i">
                    </app-file-preview>
                  </div>
                </ng-container>

                <!-- Documents -->
                <ng-template #documentBlock>
                  <div class="media-area">
                    <a [href]="media.url" target="_blank" class="doc-link">
                      <i style="font-size: 24px; color: white;" class="bi bi-file-earmark-text"></i>
                    </a>
                  </div>

                </ng-template>
              </div>

              <!-- Common details for all -->
              <div class="media-details">
                <span class="media-name over-flow-word">{{ media.name || 'Untitled File' }}</span>
                <div class="media-meta">
                  <span class="media-size">{{ media.size || '-' }}</span>
                  <span class="media-date">{{ formatDate(message.timestamp) }}</span>
                  <span class="media-time">{{ formatTime(message.timestamp) }}</span>
                  <button class="download-btn" (click)="downloadFile(media)">
                    <i class="bi bi-download"></i>
                  </button>
                </div>
              </div>

            </ng-container>
          </div>
          <div class="empty-media d-flex justify-content-center align-items-center"  *ngIf="!allMessages || allMessages?.length === 0">
            <span>No media found.</span>
          </div>



        </div>

        <!-- Links Tab -->
        <div class="links-list" *ngIf="activeInfoTab === 'links'">
          <div class="link-item" *ngFor="let link of linkItems">
            <div class="link-icon">
              <img src="images/icons/player_running.png" alt="" style="height: 40px;">
              <!-- <i class="bi bi-link"></i> -->
            </div>
            <div class="link-details">
              <span class="link-url">{{ link.url }}</span>
              <div class="link-meta">
                <span class="link-date">{{ formatDate(link.timestamp) }}</span>
                <span class="link-time">{{ formatTime(link.timestamp) }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Queries Tab -->
        <div class="queries-list" *ngIf="activeInfoTab === 'queries'">
          <div class="query-item" *ngFor="let query of queryItems">
            <div class="query-icon">
              <img src="images/icons/question_blue.png" alt="" style="height: 40px;">
              <!-- <i class="bi bi-question-circle"></i> -->
            </div>
            <div class="query-details">
              <span class="query-text">{{ query.question }}</span>
              <div class="query-meta">
                <span
                  class="query-status-badge"
                  [class.resolved]="query.status === 'resolved'">
                  {{ query.status === 'resolved' ? 'Resolved' : 'In Progress' }}
                </span>
                <span class="query-date">{{ formatDate(query.timestamp) }}</span>
                <span class="query-time">{{ formatTime(query.timestamp) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #newChatPopup let-modal class="modal fade" id="newChatModal" aria-labelledby="newChatModalLabel">
    <div class="modal-content">
      <div class="modal-header d-flex justify-content-between" style="padding: 1.5rem 2rem; font-size: var(--text-lg1) !important;">
        <h6 class="modal-title mb-0 bd-7" id="newChatModalLabel">Add member</h6>
        <img class="close" data-dismiss="modal" aria-label="Close"
            (click)="onClose();modal.dismiss();"
            src="images/icons/cancel.png">
      </div>

      <div class="modal-body" style="display: grid; grid-gap: 15px; padding: 1rem 2rem; max-height: 70vh; overflow-y: auto;">
        <div class="search-section">
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-search"></i></span>
            <input type="text" class="form-control" placeholder="Search members..."
              (keydown.enter)="searchTermAddMemeber()"
              [(ngModel)]="searchTermAdd">
          </div>
        </div>
        <div class="tabs-container">
          <button
            class="tab-button"
            [class.active]="addMemeberTab === 'member'"
            (click)="setActiveMembersTabpop('member')">
            Players
          </button>
          <button
            class="tab-button"
            [class.active]="addMemeberTab === 'coach'"
            (click)="setActiveMembersTabpop('coach')">
            Coaches
          </button>
          <button
            class="tab-button"
            [class.active]="addMemeberTab === 'admin'"
            (click)="setActiveMembersTabpop('admin')">
            Admins
          </button>
          <button
            class="tab-button"
            [class.active]="addMemeberTab === 'parent'"
            (click)="setActiveMembersTabpop('parent')">
            Parents
          </button>
        </div>

        <div class="contacts-section" (scroll)="onScroll($event)">
          <div *ngFor="let contact of filteredContacts" class="d-flex align-items-center mb-2 p-2 rounded cursor-pointer"
              (click)="toggleContactSelection(contact)">

            <div class="position-relative me-3">
              <img [src]="contact.avatar"
                  [alt]="contact.name"
                  class="rounded-circle border"
                  style="width:44px; height:44px; object-fit:cover;"
                  onerror="this.src='/placeholder.svg?height=40&width=40'">
              <!-- <span class="position-absolute bottom-0 end-0 translate-middle p-1 border border-light rounded-circle"
                    [ngClass]="contact.status === 'online' ? 'bg-success' : 'bg-secondary'">
              </span> -->
            </div>

            <div class="flex-fill">
              <div class="d-flex over-flow-word" style="font-size: var(--text-base);">
                <i class="bi me-1" [ngClass]="[getRoleIcon(contact.role), getRoleColor(contact.role)]"></i>
                <div class="over-flow-word">{{ contact.name  | string : 'title'}}</div>
              </div>
              <div class="text-muted d-flex align-items-center" style="font-size: var(--text-sm);">

                <span>{{ contact.role | string : 'title' }}</span>
                <span class="ms-2" *ngIf="contact.lastSeen">• {{ contact.lastSeen | string : 'sentence' }}</span>
              </div>
            </div>

            <div class="form-check">
              <input class="form-check-input"
                    type="checkbox"
                    [checked]="contact.selected"
                    [id]="'contact-' + contact.id">
            </div>
          </div>
          <div *ngIf="is_loading_members" class="d-flex flex-column" style="gap: .325rem;">
            <div class="d-flex"*ngFor="let elm of [1,2,3,4,5]">
              <app-skeleton-loader [type]="'circle'" class="mb-2 me-3" [width]="44" [height]="44" ></app-skeleton-loader>
              <div class="d-flex flex-column w-100">
                <app-skeleton-loader [type]="'square'" class="mb-2" [width]="320" [height]="20" ></app-skeleton-loader>
                <app-skeleton-loader [type]="'square'" class="" [width]="250" [height]="15" ></app-skeleton-loader>
              </div>
            </div>
          </div>

          <div class="text-center text-muted p-3" *ngIf="filteredContacts.length === 0 && !is_loading_members">
            <i class="bi bi-search fs-4 d-block mb-2"></i>
            No members found
          </div>
        </div>
      </div>

      <div class="row mt-3" style="padding: 0rem 2rem;">
        <div class="col-md-6">
          <div class="form-group">
            <div class="col-sm-12 pl-0">
              <button class="btn btn-outline-dark btn-fw w-100 main-height"
                      (click)="modal.dismiss(); onClose()">
                Cancel
              </button>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <div class="col-sm-12 pl-0">
              <button class="btn btn-primary btn-fw w-100 main-height"
                      [disabled]="selectedCount === 0"
                      (click)="AddToGroup(); modal.dismiss()">
                <span>Add to chat</span>
                <span class="badge bg-light text-dark ms-2" *ngIf="selectedCount > 0">{{ selectedCount }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </ng-template>

  <ng-template #chatModal let-modal class="modal fade">
    <div class="modal-content">
      <!-- Header -->
      <div class="modal-header">
        <!-- Dynamic header based on current step -->
        <div class="header-left" *ngIf="currentStep === 'setup'">
          <button class="btn p-0 me-3" style="height: 20px;" (click)="goToStep('selection')">
            <i class="bi bi-arrow-left fs-5"></i>
          </button>
          <h6 class="modal-title mb-0">Setup group</h6>
        </div>
        <h6 class="modal-title" *ngIf="currentStep === 'selection'">New chat</h6>
        <img class="close" (click)="closeModal()" src="images/icons/cancel.png" alt="">
      </div>

      <!-- Body - Contact/Group Selection Step -->
      <div class="modal-body" *ngIf="currentStep === 'selection'">
        <!-- Tabs -->
        <div class="tabs-container">
          <button
            class="tab-button"
            [class.active]="activeTabpop === 'contacts'"
            (click)="setActiveTabpop('contacts')">
            Members
            <!-- ({{ contacts.length }}) -->
          </button>
          <button
            class="tab-button"
            [class.active]="activeTabpop === 'groups'"
            (click)="setActiveTabpop('groups')">
            Groups ({{ groups.length }})
          </button>
        </div>

        <!-- Search -->
        <div class="search-section">
          <div class="input-group" style="background: #f7f7f7;">
            <span class="input-group-text main-height">
              <i class="bi bi-search"></i>
            </span>
            <input style="background: #f7f7f7;"
              type="text"
              class="form-control main-height"
              [placeholder]="activeTabpop === 'contacts' ?  addMemeberTab === 'parent'?'Search child name...' :'Search members...': 'Search groups...'"
              (ngModelChange)="onSearchChange($event)"
              [(ngModel)]="searchTerm">
          </div>
        </div>

        <!-- Group Filter (only for contacts tab) -->
        <div class="filter-section" *ngIf="activeTabpop === 'contacts'">
          <div class="dropdown">
            <button class="btn btn-outline-secondary dropdown-toggle filter-button"
                    type="button" (click)="toggleDropdown()"
                    data-bs-toggle="dropdown"
                    aria-expanded="false">
              <i class="bi bi-funnel"></i>
              Filter by group ({{ selectedGroupFiltername }})
            </button>
            <ul class="dropdown-menu w-100" [class.show]="isDropdownOpen">
              <li><a class="dropdown-item cursor-pointer" (click)="setGroupFilter(null)">All</a></li>
              <li *ngFor="let group of filteredGroups">
                <a class="dropdown-item text-wrap cursor-pointer" [title]="group.name" (click)="setGroupFilter(group.id)">{{ group.name }}</a>
              </li>
            </ul>
          </div>
        </div>

        <div class="tabs-container" *ngIf="activeTabpop === 'contacts'">
          <button
            class="tab-button"
            [class.active]="addMemeberTab === 'member'"
            (click)="setNewChatMembersTabpop('member')">
            Players
          </button>
          <button
            class="tab-button"
            [class.active]="addMemeberTab === 'coach'"
            (click)="setNewChatMembersTabpop('coach')">
            Coaches
          </button>
          <button
            class="tab-button"
            [class.active]="addMemeberTab === 'admin'"
            (click)="setNewChatMembersTabpop('admin')">
            Admins
          </button>
          <button
            class="tab-button"
            [class.active]="addMemeberTab === 'parent'"
            (click)="setNewChatMembersTabpop('parent')">
            Parents
          </button>
        </div>

        <!-- Content Count -->
        <!-- <div class="content-count">
          <span *ngIf="activeTabpop === 'contacts'">{{ filteredContacts.length }} total contacts</span>
          <span *ngIf="activeTabpop === 'groups'">{{ filteredGroups.length }} groups available</span>
        </div> -->

        <!-- Selection Summary -->
        <div class="selection-summary" *ngIf="totalSelectedCount > 0">
          <div class="selected-count">
            <i class="bi bi-people-fill"></i>
            {{ totalSelectedCount }} selected
          </div>
          <button class="btn btn-sm" style="font-size: 12px;" (click)="resetSelections()">Clear all</button>
        </div>

        <!-- Contacts Tab Content -->
        <div class="content-section" *ngIf="activeTabpop === 'contacts'" (scroll)="onScrollNewConv($event)">
          <div *ngFor="let contact of filteredContacts"
              class="contact-item"
              (click)="toggleContactSelection(contact)" >

            <!-- Avatar -->
            <div class="avatar-container">
              <img [src]="contact.avatar"
                  class="avatar"
                  (error)="onImgError($event)">
              <span class="status-indicator"
                    [class.online]="contact.status === 'online'"
                    [class.offline]="contact.status === 'offline'"></span>
            </div>

            <!-- Info -->
            <div class="contact-info">
              <div class="contact-name">
                <i class="bi me-1" [ngClass]="[getRoleIcon(contact.role), getRoleColor(contact.role)]"></i>
                <span class="over-flow-word" [title]="contact.name">{{ contact.name | string:'title'}}</span>
              </div>
              <div class="contact-details">
                <span>{{ contact.role }}</span>
                <!-- <span *ngIf="contact.lastSeen"> • {{ contact.lastSeen }}</span> -->
              </div>
              <div class="contact-groups" *ngIf="contact.groups && contact.groups.length > 0">
                <i class="bi bi-people"></i>
                <span class="over-flow-word" [title]="contact.groups.join(', ')">{{ contact.groups.join(', ') }}</span>
              </div>
            </div>

            <!-- Selection -->
            <div class="selection-indicator">
              <div class="custom-checkbox" [class.checked]="contact.selected">
                <i class="bi bi-check" *ngIf="contact.selected"></i>
              </div>
            </div>
          </div>

          <div *ngIf="is_loading_members" class="d-flex flex-column" style="gap: .325rem;">
            <div class="d-flex"*ngFor="let elm of [1,2,3,4,5]">
              <app-skeleton-loader [type]="'circle'" class="mb-2 me-3" [width]="44" [height]="44" ></app-skeleton-loader>
              <div class="d-flex flex-column w-100">
                <app-skeleton-loader [type]="'square'" class="mb-2" [width]="320" [height]="20" ></app-skeleton-loader>
                <app-skeleton-loader [type]="'square'" class="" [width]="250" [height]="15" ></app-skeleton-loader>
              </div>
            </div>
          </div>

          <!-- No Results -->
          <div class="no-results mt-5" *ngIf="filteredContacts.length === 0 && !is_loading_members">
            <i class="bi bi-search fs-4"></i>
            <p>No contacts found</p>
          </div>
        </div>

        <!-- Groups Tab Content -->
        <div class="content-section" *ngIf="activeTabpop === 'groups'">
          <div *ngFor="let group of filteredGroups"
              class="group-item"
              (click)="toggleGroupSelection(group)">

            <!-- Avatar -->
            <div class="avatar-container">
              <img [src]="group.avatar"
                  class="avatar group-avatar"
                  (error)="onImgError($event)">
            </div>

            <!-- Info -->
            <div class="group-info">
              <div class="group-name">
                <i class="bi bi-people me-1 text-primary"></i>
                <span class="text-wrap" [title]="group.name">{{ group.name | string:'title' }}</span>
              </div>
              <div class="group-details">
                {{ group.memberCount }} members <span *ngIf="group.lastActivity">• {{ group.lastActivity }}</span>
              </div>
              <div class="group-description over-flow-word">
                {{ group.description }}
              </div>
            </div>

            <!-- Selection -->
            <div class="selection-indicator">
              <div class="custom-checkbox" [class.checked]="group.selected">
                <i class="bi bi-check" *ngIf="group.selected"></i>
              </div>
            </div>
          </div>

          <div *ngIf="is_loading_groups" class="d-flex flex-column" style="gap: .325rem;">
            <div class="d-flex"*ngFor="let elm of [1,2,3,4,5]">
              <app-skeleton-loader [type]="'circle'" class="mb-2 me-3" [width]="44" [height]="44" ></app-skeleton-loader>
              <div class="d-flex flex-column w-100">
                <app-skeleton-loader [type]="'square'" class="mb-2" [width]="320" [height]="20" ></app-skeleton-loader>
                <app-skeleton-loader [type]="'square'" class="" [width]="250" [height]="15" ></app-skeleton-loader>
              </div>
            </div>
          </div>

          <!-- No Results -->
          <div class="no-results mt-5" *ngIf="filteredGroups.length === 0 && !is_loading_groups">
            <i class="bi bi-search fs-4"></i>
            <p>No groups found</p>
          </div>
        </div>
      </div>

      <!-- Body - Group Setup Step -->
      <!-- Added group setup content as second step within same modal -->
      <div class="modal-body setup-body" *ngIf="currentStep === 'setup'">
        <!-- Group Photo -->
        <div class="group-photo-section">
          <div class="photo-upload-container">
            <div class="photo-preview" [style.background-image]="groupPhoto ? 'url(' + groupPhoto + ')' : 'none'">
              <div class="photo-placeholder" *ngIf="!groupPhoto">
                <i class="bi bi-person-circle fs-1"></i>
              </div>
            </div>
            <div class="photo-overlay">
                <label for="groupPhotoInput" class="photo-upload-btn">
                  <i class="bi bi-camera-fill"></i>
                </label>
                <input type="file"
                      id="groupPhotoInput"
                      accept="image/*"
                      (change)="onGroupPhotoUpload($event)"
                      style="display: none;">
            </div>
          </div>
          <p class="photo-help-text">Add a group photo to help members identify this group</p>
        </div>

        <!-- Group Name -->
        <div class="group-name-section">
          <label class="form-label">Group name</label>
          <input type="text"
                class="form-control" style="border-radius: 10px !important;"
                [(ngModel)]="groupName"
                placeholder="Enter group name">
          <small class="form-text text-muted">Choose a name that describes the purpose of this group</small>
        </div>

        <!-- Participants -->
        <div class="participants-section">
          <h6 class="section-title">Participants ({{ selectedParticipants.length }})</h6>

          <div class="participants-list">
            <div *ngFor="let participant of selectedParticipants" class="participant-item">
              <!-- Avatar -->
              <div class="participant-avatar">
                <img [src]="participant.avatar"
                    [alt]="participant.name"
                    class="avatar"
                    onerror="this.src='/placeholder.svg?height=40&width=40'">
              </div>

              <!-- Info -->
              <div class="participant-info">
                <div class="participant-name over-flow-word">{{ participant.name }}</div>
                <div class="participant-role">{{ participant.role }}</div>
              </div>

              <!-- Remove Button -->
              <button class="btn btn-link text-danger p-0"
                      (click)="removeParticipant(participant)"
                      *ngIf="selectedParticipants.length > 1">
                <i class="bi bi-x-lg"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer - Selection Step -->
      <div class="modal-footer" *ngIf="currentStep === 'selection'">
        <button class="btn btn-outline-secondary" (click)="closeModal()">
          Cancel
        </button>
        <!-- Updated button to navigate to setup step instead of separate modal -->
        <button class="btn btn-primary"
                [disabled]="totalSelectedCount === 0"
                (click)="onCreateGroupChat()">
          <span *ngIf="activeTabpop === 'contacts' && totalSelectedCount === 0">Start chat</span>
          <span *ngIf="activeTabpop === 'contacts' && selectedContactCount === 1">Start chat</span>
          <span *ngIf="activeTabpop === 'contacts' && selectedContactCount > 1">Create group chat</span>
          <span *ngIf="activeTabpop === 'groups'">Create group chat</span>
          <span class="badge bg-light text-dark ms-2" *ngIf="totalSelectedCount > 0">
            {{ totalSelectedCount }}
          </span>
        </button>
      </div>

      <!-- Footer - Setup Step -->
      <!-- Added footer for setup step -->
      <div class="modal-footer" *ngIf="currentStep === 'setup'">
        <button class="btn btn-outline-secondary" (click)="goToStep('selection')">
          Back
        </button>
        <button class="btn btn-primary"
                [disabled]="!groupName.trim() || selectedParticipants.length === 0"
                (click)="createGroups()">
          Create group
        </button>
      </div>
    </div>
  </ng-template>
</ng-container>

<ng-template #noAccess>
  <app-no-access></app-no-access>
</ng-template>
